import { createContext } from 'react';

const CommsContext = createContext(null);

export default CommsContext;
